import React from "react";
import classnames from "classnames";
import { Modal, Form } from "react-bootstrap";

// import action
import { updateSourceOfFund } from "../../actions/sourceoffundAction";

// import lib
import { toastAlert } from "../../lib/toastAlert";

const initialFormValue = {
  souceoffundId: "",
  name: "",
  lt: "",
  gte: "",
  currency: "",
  status: "active",
};

class CountryUpdateModal extends React.Component {
  constructor() {
    super();
    this.state = {
      loader: false,
      formValue: initialFormValue,
      errors: {},
    };
  }

  componentWillReceiveProps(nextProps) {
    const { record, imageUrl } = nextProps;
    if (record) {
      let formData = {
        souceoffundId: record._id,
        name: record.name,
        currency: record.currency,
        lt: record.lt,
        gte: record.gte,
        status: record.status,
      };
      this.setState({ formValue: formData });
    }
  }

  handleChange = (e) => {
    e.preventDefault();
    const { name, value } = e.target;
    let formData = { ...this.state.formValue, ...{ [name]: value } };
    this.setState({ formValue: formData });
  };

  handleClose = () => {
    const { onHide } = this.props;
    onHide();
    this.setState({ formValue: initialFormValue, errors: {} });
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    const { formValue } = this.state;
    const { fetchData } = this.props;

    try {
      this.setState({ loader: true });
      const { status, loading, message, error } = await updateSourceOfFund(this.state.formValue);
      this.setState({ loader: loading });
      if (status == "success") {
        this.handleClose();
        fetchData();
        toastAlert("success", message, "CountryUpdateModal");
      } else if (status == "failed") {
        if (error) {
          this.setState({ errors: error });
        } else {
          toastAlert("error", message, "CountryUpdateModal");
        }
      }
    } catch (err) { }
  };

  render() {
    const {
      name,
      currency,
      lt,
      gte,
      status,
    } = this.state.formValue;
    const { errors, loader } = this.state;
    const { isShow } = this.props;

    return (
      <div>
        <Modal
          show={isShow}
          onHide={this.handleClose}
          aria-labelledby="contained-modal-title-vcenter"
          size="lg"
          centered
          scrollable={true}
        >
          <Modal.Header closeButton>
            <h4 className="modal-title">Update Source of Fund</h4>
          </Modal.Header>
          <Modal.Body>
            <form>
              <div className="row mt-2">
                <div className="col-md-3">
                  <label>Less than</label>
                </div>
                <div className="col-md-9">
                  <input
                    name="lt"
                    type="text"
                    value={lt}
                    onChange={this.handleChange}
                    error={errors.lt}
                    className={classnames("form-control", {
                      invalid: errors.lt,
                    })}
                  />
                  <span className="text-danger">{errors.lt}</span>
                </div>
              </div>
              <div className="row mt-2">
                <div className="col-md-3">
                  <label>Greater or Equal to</label>
                </div>
                <div className="col-md-9">
                  <input
                    name="gte"
                    type="text"
                    value={gte}
                    onChange={this.handleChange}
                    error={errors.gte}
                    className={classnames("form-control", {
                      invalid: errors.gte,
                    })}
                  />
                  <span className="text-danger">{errors.gte}</span>
                </div>
              </div>
              <div className="row mt-2">
                <div className="col-md-3">
                  <label>Name</label>
                </div>
                <div className="col-md-9">
                  <input
                    name="name"
                    type="text"
                    value={name}
                    onChange={this.handleChange}
                    error={errors.name}
                    className={classnames("form-control", {
                      invalid: errors.name,
                    })}
                  />
                  <span className="text-danger">{errors.name}</span>
                </div>
              </div>
              <div className="row mt-2">
                <div className="col-md-3">
                  <label>Currency</label>
                </div>
                <div className="col-md-9">
                  <input
                    name="currency"
                    type="text"
                    value={currency}
                    onChange={this.handleChange}
                    error={errors.currency}
                    className={classnames("form-control", {
                      invalid: errors.currency,
                    })}
                  />
                  <span className="text-danger">{errors.currency}</span>
                </div>
              </div>
              <div className="row mt-2">
                <div className="col-md-3">
                  <label>Status</label>
                </div>
                <div className="col-md-9">
                  <Form.Control
                    name="status"
                    value={status}
                    onChange={this.handleChange}
                    as="select"
                    custom
                  >
                    <option value={"active"}>Active</option>
                    <option value={"deactive"}>Deactive</option>
                  </Form.Control>
                  <span className="text-danger">{errors.type}</span>
                </div>
              </div>
            </form>
          </Modal.Body>
          <Modal.Footer>
            <button
              type="button"
              className="btn btn-secondary"
              data-dismiss="modal"
              onClick={this.handleClose}
            >
              Close
            </button>
            <button onClick={this.handleSubmit} className="btn btn-primary">
              {loader && <i class="fas fa-spinner fa-spin"></i>}Update Source of Fund
            </button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

export default CountryUpdateModal;
